import { EnumSchema, FromSchema } from 'libs/entities/common/src/SchemaOperations';
import { z } from 'zod';

export enum CreditReviewInternationalScore {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    NotRated = 'Not Rated',
    BankruptcyProceedingsFiled = 'Bankruptcy proceedings filed',
}

export const BusinessCreditReviewStatusSchema = z.enum(['pending', 'approved', 'rejected']);

export const BusinessCreditScoreSchema = z
    .object({
        value: z.number(),
    })
    .strict();

export const BusinessInternationalScoreSchema = z
    .object({
        value: EnumSchema(CreditReviewInternationalScore),
    })
    .strict();

export const BusinessRecommendedCreditLimitSchema = z
    .object({
        amount: z.number(),
        currency: z.string(),
    })
    .strict();

export class BusinessCreditScore extends FromSchema(BusinessCreditScoreSchema) {
    value: number;
}

export class BusinessInternationalScore extends FromSchema(BusinessInternationalScoreSchema) {
    value: CreditReviewInternationalScore;
}

export class BusinessRecommendedCreditLimit extends FromSchema(BusinessRecommendedCreditLimitSchema) {
    amount: number;
    currency: string;
}

export enum BusinessCreditReviewStatus {
    PENDING = 'pending',
    IN_PROGRESS = 'in-progress',
    READY = 'ready',
    FAILED = 'failed',
}

export const BusinessCreditReviewSchema = z
    .object({
        creditScore: BusinessCreditScoreSchema.optional(),
        internationalScore: BusinessInternationalScoreSchema.optional(),
        recommendedCreditLimit: BusinessRecommendedCreditLimitSchema.optional(),
        status: EnumSchema(BusinessCreditReviewStatus),
    })
    .strict();

export class BusinessCreditReview extends FromSchema(BusinessCreditReviewSchema) {
    status?: BusinessCreditReviewStatus;
    creditScore?: BusinessCreditScore;
    internationalScore?: BusinessInternationalScore;
    recommendedCreditLimit?: BusinessRecommendedCreditLimit;
}
